import { Button, WideAlert, Icons } from '@components';
import React from 'react';
import './styles.css';
import { useNavigate, Link } from 'react-router-dom';
import { mdiCommentAlertOutline } from '@mdi/js';
import { SOLICITACAO_RESGATE_PARCIAL_FORMULARIO } from '../../../../common/utils/paths';

export const TermosResgateSimulacao = ({ setViewTerms }) => {
  const navigate = useNavigate();
  return (
    <>
      <WideAlert className="mb-4" iconClear={false}>
        <div className="d-block d-lg-flex align-items-center">
          <Icons
            path={mdiCommentAlertOutline}
            color="var(--primary-color)"
            size={4}
            style={{ marginRight: 18 }}
          />
          <p className="ts-16">
            <strong>Aviso importante:</strong> nesta página, você fará somente a
            Simulação do Resgate Parcial do seu Saldo de Contas. Para fazer a
            solicitação, acesse a página de{' '}
            <Link to={SOLICITACAO_RESGATE_PARCIAL_FORMULARIO}>
              requerimento de resgate parcial.
            </Link>
          </p>
        </div>
      </WideAlert>
      <div className="card">
        <div className="card-body">
          <h2>
            <strong>Como funciona o simulador de resgate?</strong>
          </h2>
          <div className="terms">
            <p className="description">
              Esse simulador oferece a você uma <b>ESTIMATIVA</b> de valores de
              resgate parcial do seu saldo de contas. Ele irá te ajudar a
              compreender o impacto aproximado do resgate parcial em seu plano
              de previdência, explorar os cenários e ajustar os valores de
              acordo com sua situação. Com esta ferramenta, visamos oferecer
              informações para que você esteja apto e seguro para tomar decisões
              financeiras adequadas.
            </p>
            <p className="description">
              Por ser uma estimativa, podem ocorrer diferenças entre o resultado
              da simulação e o valor real, após conclusão do processo.
            </p>
            <p className="description">
              O preenchimento do simulador não garante seu pedido de resgate.
            </p>
            <p className="description">
              Para fazer sua solicitação, acesse o item Requerimento de Resgate
              Parcial disponível na tela inicial da Área do Participante.
            </p>
            <p className="description">
              Confira nos links abaixo mais informações.
            </p>
            <p className="description">
              <a
                href="https://institucional.forluz.org.br/noticias-internas/CNPC-50---Perguntas-Frequentes-(FAQ)=&Id=2047"
                target="_blank"
                rel="noreferrer"
              >
                Perguntas Frequentes
              </a>
            </p>
            <p className="description">
              <a
                href="https://youtu.be/4nQjW4u1xFA"
                target="_blank"
                rel="noreferrer"
              >
                Tutorial Resgate Parcial
              </a>
            </p>
            <p className="description">
              <a
                href="https://youtu.be/rIuXkjMchts "
                target="_blank"
                rel="noreferrer"
              >
                Entenda os Regimes de Tributação
              </a>
            </p>
            <p className="description">
              Em caso de dúvidas, entre em contato com a nossa Central de
              Atendimento pelo 0800 090 9090.
            </p>
          </div>

          <div className="tbrow" />
          <br />
          <div className="tbbutton  gap-4">
            <Button
              transparent
              color="orange"
              className="max-180 "
              onClick={() => navigate(-1)}
            >
              Voltar
            </Button>
            <Button className="max-180" onClick={() => setViewTerms(false)}>
              Iniciar simulação
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
